<template>
    <div>
        <a-modal centered :bodyStyle="{ padding: 0 }" :visible="visible" :closable="false" :footer="null">
            <div style="margin: 8px">
                <div>
                    <label class="custom-close w-100 fs-16"><span @click="cancel"> x close</span> </label>
                </div>
                <template v-for="(popup, key) in data.popup">
                    <div v-if="key == step" :key="key">
                        <div class="image-wrapped" v-if="popup.image_full">
                            <img :src="popup.image_full" class="image" />
                        </div>
                        <div v-if="popup.title || popup.msg" style="background-color: #fff; padding-top: 5px" class="text-center">
                            <label class="title fs-20" v-if="popup.title">
                                {{ popup.title }}
                            </label>
                            <label class="description fs-18" v-if="popup.msg">
                                {{ popup.msg }}
                            </label>
                        </div>
                        <div class="custom-modal-footer">
                            <div style="text-align: center; margin-top: 8px">
                                <a-button v-if="popup.display_button" size="large" class="text-center primary-btn ant-button-label-custom fs-20" style="border-radius: 0; width: 150px" @click="view(popup)">
                                    <strong>ดูรายละเอียด</strong>
                                </a-button>
                                <label class="fs-16" style="padding: 5px 16px 8px 16px; display: block">
                                    <span @click="notShowAgain(popup.priv_id)"> ไม่แสดงหน้านี้อีก</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </a-modal>
    </div>
</template>
<script>
import store from 'store';
export default {
    props: ['visible', 'step', 'data'],
    beforeCreate() {
        this.form = this.$form.createForm(this, { name: 'form_in_modal' });
    },
    data() {
        return {};
    },
    methods: {
        view(popup) {
            var type = popup.type;
            var path = '';
            var query = {};
            query.back_path = '/home';
            if (type == 'news') {
                path = '/inbox-detail';
                query.inbox_id = popup.xid;
            } else if (type == 'privilege') {
                path = '/privilege-detail';
                query.priv_id = popup.xid;
            } else if (type == 'activity') {
                path = '/activity-detail';
                query.act_id = popup.xid;
            } else if (type == 'delight') {
                path = '/delight-detail';
                query.delight_id = popup.xid;
            } else if (type == 'reward') {
                path = '/reward-condition';
                query.priv_id = popup.xid;
            }
            this.$router.replace({
                path: path,
                query: query,
            });
        },
        notShowAgain(priv_id) {
            var not_show_again_ids = store.get('not_show_again_priv_ids_popup');
            if (not_show_again_ids == undefined) {
                not_show_again_ids = [];
            }
            if (not_show_again_ids.indexOf(priv_id) == -1) {
                not_show_again_ids.push(priv_id);
            }
            console.log('not_show_again_ids', not_show_again_ids);
            store.set('not_show_again_priv_ids_popup', not_show_again_ids);
            this.$emit('on-cancel');
        },
        cancel() {
            this.$emit('on-cancel');
        },
    },
};
</script>
<style scoped>
.title {
    font-weight: 600;
    margin: 0;
}
.description {
    font-weight: 300;
    margin: 0 8px 0 16px;
    color: #000 !important;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
.custom-modal-footer {
    background: transparent;
    padding: 0px 10px;
}
.custom-modal-footer-single-close-btn {
    background: linear-gradient(0deg, #ff7105, #ff9500 100%) no-repeat;
    color: #fff;
    width: 100%;
}
.image-wrapped {
    margin-top: 4px;
    text-align: center;
}
.image {
    width: 100%;
    max-height: 360px;
}
.ดูรายละเอียด {
    border-radius: 0;
    width: 50%;
    min-width: 92px;
    height: 32px;
    margin: 0;
    margin-top: 8px;
}
.custom-close {
    font-weight: 300;
    margin: 0;
    color: #707070 !important;
    text-align: right;
    opacity: 0.5;
    margin-top: 5px;
}
</style>